var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.clubInfoList, function (clubInfo, clubInfoIndex) {
      return _c(
        "div",
        {
          key: `info-about-${clubInfoIndex}`,
          class: { "mt-8": clubInfoIndex !== 0 },
        },
        [
          _c("div", { staticClass: "text-h6 text--text mb-2" }, [
            _vm._v("\n      " + _vm._s(clubInfo.title) + "\n    "),
          ]),
          _vm._v(" "),
          _vm.useListElement
            ? _c(
                clubInfo.isOrderedListElement ? "ol" : "ul",
                { tag: "component" },
                _vm._l(clubInfo.sentences, function (sentence, sentenceIndex) {
                  return _c("li", {
                    key: sentenceIndex,
                    staticClass: "text-body-1 text--text mb-2",
                    domProps: { innerHTML: _vm._s(sentence) },
                  })
                }),
                0
              )
            : [
                _c("div", { staticClass: "text-body-1 text--text" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(clubInfo.sentences.join(" ")) +
                      "\n      "
                  ),
                ]),
              ],
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }